import { useCallback, useState } from 'react';

interface FilterParams {
  workflowId: string;
  workflowName: string; // Keep for display purposes
  ruleId: string;
  ruleName: string; // Keep for display purposes
  status: string[];
  startDate: string;
  endDate: string;
}

const INITIAL_FILTER_PARAMS: FilterParams = {
  workflowId: '',
  workflowName: '',
  ruleId: '',
  ruleName: '',
  status: [],
  startDate: '',
  endDate: '',
};

export const useWorkflowExecutionsFilters = () => {
  const [filterParams, setFilterParams] = useState<FilterParams>(INITIAL_FILTER_PARAMS);

  const updateFilter = useCallback((updates: Partial<FilterParams>) => {
    setFilterParams((prev) => ({ ...prev, ...updates }));
  }, []);

  const clearFilters = useCallback(() => {
    setFilterParams(INITIAL_FILTER_PARAMS);
  }, []);

  return {
    filterParams,
    updateFilter,
    clearFilters,
  };
};
